<template>
	<div class="chess-info">
		<div class="chess-info-board">
			<canvas :id="'sgf_' + chessSgf.chess_sgf.id" width="220" height="220"></canvas>
		</div>
		<div class="chess-info-info">
			<h1 class="title">{{parseSgf.ev || '空'}}</h1>
			<hr>
			<div class="players">
				<div class="player left">
					<img src="../assets/黑子.png" alt="">
					<span>{{ parseSgf.pb }}</span>
				</div>
				<div class="player right">
					<img src="../assets/白子.png" alt="">
					<span>{{ parseSgf.pw }}</span>
				</div>
			</div>
			<div class="star">
				<img src="../assets/星2.png" v-for="i in star">
				<img src="../assets/星1.png" v-for="i in 3 - star">
			</div>
		</div>
	</div>
</template>

<script>
import Board from "../../components/go/board"
import * as go from "../../components/go/go"
import w from "../assets/白子.png"
import b from "../assets/黑子.png"
import boardImg from "../assets/棋盘.jpg"
export default {
	props: {
		chessSgf: {
			required: true
		}
	},
	computed: {
		parseSgf() {
			let sgf = this.chessSgf.chess_sgf.sgf
			let p = {
				pw: sgf.match(/PW\[(.*?)\]/),
				pb: sgf.match(/PB\[(.*?)\]/),
				sz: sgf.match(/SZ\[(.*?)\]/),
				ev: sgf.match(/EV\[(.*?)\]/),
				mv: sgf.match(/[BW]\[[a-z]{2}\]/g),
			}
			return {
				pw: p.pw ? p.pw[1] : "",
				pb: p.pb ? p.pb[1] : "",
				sz: p.sz ? p.sz[1] : 19,
				ev: p.ev ? p.ev[1] : "",
				mv: p.mv ? p.mv : []
			}
		},
		star() {
			return this.scoreToStar(this.chessSgf.score)
		}
	},
	created() {
		this.$nextTick(() => {
			this.draw(document.getElementById('sgf_' + this.chessSgf.chess_sgf.id), this.chessSgf.chess_sgf.sgf)
		})
	},
	methods: {
		scoreToStar(score) {
			if (score >= 10000 && score < 50000) {
				return 1
			} else if (score >= 50000 && score < 100000) {
				return 2
			} else if (score >=100000) {
				return 3
			}
			return 0
		},
		draw(canvas, sgf) {
			sgf = this.formatSgfString(sgf)
			let steps = go.parseSgf(sgf)
			let board = new Board(canvas, {
				size: 19,
				boardImage: boardImg,
				black: b,
				white: w,
			})
			board.boardArray = go.stepsToBoardArray(steps, [20])
			board.redraw()
		},
		formatSgfString(data){
			var index = -1;
			var desc = "";
			var desc_result = /C\[([.\s\S]*?)\]/.exec(data);
			if (desc_result != null) {
				desc = desc_result[1];
				index = data.indexOf(desc);
			}

			var sgf = "";
			if (index > 0) {
				sgf = data.substr(0, index).replace(/[\r\n|↵]/g, "").replace(/\ +/g, "").replace(/[ ]/g, "") +
					desc + data.substr(index + desc.length).replace(/[\r\n]/g, "").replace(/\ +/g, "").replace(/[ ]/g, "");
			} else {
				sgf = data.replace(/[\r\n|↵]/g, "").replace(/\ +/g, "").replace(/[ ]/g, "");
			}

			if (sgf[0] == '(') sgf = sgf.substr(1);
			if (sgf[sgf.length - 1] == ')') sgf = sgf.substr(0, sgf.length - 1);
			return sgf;
		},
	},
}
</script>

<style scoped>
*, div, h1 {
	font-family: Microsoft Yahei;
}
hr {
	border-width: 0 0 1px 0;
	border-color: #357fc2;
	width: 90%;
}
.chess-info {
	margin: 5px;
	cursor: pointer;
}
.chess-info-board {
	width: 230px;
	height: 230px;
	padding: 5px;
	box-sizing: border-box;
	background-color: #18629f;
}
.chess-info-info {
	width: 230px;
	background-color: #18629f;
	margin: 5px 0;
	box-sizing: border-box;
	padding-top: 8px;
}
.chess-info-info .title {
	color: yellow;
	font-size: 18px;
	text-align: center;
	margin: 0;
	font-weight: bold;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.players {
	overflow: auto;
	margin: 5px;
}
.left {
	float: left;
}
.right {
	float: right;
	text-align: right;
}
.player {
	color: white;
	width: 50%;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}
.player * {
	vertical-align: middle;
}
.player img {
	width: 16px;
	height: 16px;
}
.star {
	height: 45px;
	text-align: right;
	margin: 5px;
}
.star img {
	width: 40px;
	height: 40px;
}
</style>



// WEBPACK FOOTER //
// ChessInfo.vue?78a713cc